export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: false,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '公司名称',
      prop: 'businessdDeptName',
      display: false,
      search: false,
    },
    {
      label: '资料名称',
      prop: 'busTypeName',
      display: false,
      search: false,
    },
    {
      label: '数量',
      prop: 'amount',
      display: false,
      search: false,
    },
    {
      label: '库位',
      prop: 'storageLocationManagementName',
      span: 24,
      display: false,
    },
    {
      label: 'id',
      prop: 'businessDeptId',
      display: false,
      hide: true,
    },
    {
      label: '关联进件编号',
      prop: 'businessCode',
      span: 24,
      display: false,
    },
    {
      label: '客户名称',
      prop: 'name',
      span: 24,
      display: false,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      span: 24,
      display: false,
    },
  ],

};
